let db = {
  save (key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  get (key, defaultValue = {}) {
    return JSON.parse(localStorage.getItem(key)) || defaultValue
  },
  remove (key) {
    localStorage.removeItem(key)
  },
  clear () {
	var bbsUrl=localStorage.getItem("bbsUrl");
    localStorage.clear()
	if(bbsUrl){
		localStorage.setItem("bbsUrl",bbsUrl);
	}
  }
}

export default db



// WEBPACK FOOTER //
// ./src/utils/localstorage.js